import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthGuard } from '../../guards/auth.guard';

import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-change-mail',
    templateUrl: './change-mail.component.html',
    styleUrls: ['./change-mail.component.css']
})
export class ChangeMailComponent implements OnInit {

    errMsg: string;
    email: string;

    constructor(private router: Router,
        private authGuard: AuthGuard,
        private authService: AuthService) { }

    ngOnInit() {
    }

    change() {
        this.authService.changeMail(this.email).subscribe(
            (res) => {
                if (res.success) {
                    this.router.navigate(['/']);
                } else {
                    this.errMsg = res.err;
                }
            },
            (error) => this.errMsg = error
        );
    }
}
